/* eslint-disable react/jsx-no-constructed-context-values */
import { createContext, useState } from 'react';
import { IntlProvider } from 'react-intl';
import messages from '../../locale';

export const LocaleContext = createContext({});

export const LocaleProvider = ({ children, pageData }) => {
  const { locale: pageLocale, id } = pageData;

  const [locale] = useState(pageLocale);

  return (
    <LocaleContext.Provider
      value={{
        locale,
        id,
      }}
    >
      <IntlProvider messages={messages[locale]} locale={locale} defaultLocale="it-IT">
        {children}
      </IntlProvider>
    </LocaleContext.Provider>
  );
};
